<h2 class="first_title">Visualizza Fascicolo {{tipoFascicolo | uppercase}} - Genera Documento</h2>
<div export-help [pageNumber]="'160'"></div>
<div class="content-page-wrapper">
  <div class="standardpanel">
    <div class="titleblock">
      <h3 class="title1level">Generazione Documento</h3>
    </div>
  
    <div class="row select-template">
      <div class="col-sm-12">
  
        Selezionare il template per il fascicolo selezionato:
  
        <div>
          <select [(ngModel)]="template" class="form-control">
            <option [ngValue]=""></option>
            <option [ngValue]="obj.id" *ngFor="let obj of resTemplate">{{obj.nome}}</option>
          </select>
        </div>
  
      </div>
    </div>
  
  
    <form [formGroup]="formGroup">  
      <!-- <div class="row">
        <div style="position: relative;">
          <div id="tooltip">
            <span id="tooltipText">Selezionare SI per creare solo l'anteprima e non allegare il documento generato al
              fascicolo</span>
            <span style="position: absolute; z-index: 999; color: #204d74;" class="glyphicon glyphicon-info-sign"></span>
          </div>
  
          <div checkBoxRadio class="col-sm-3" [labelInput]="'Anteprima'" idInput="flagAnteprima"
            formControlName="flagAnteprima" [objectReference]="flagAnteprima" (onReturn)="flagAnteprima = $event">
          </div>
        </div>
      </div> -->
  
      <div class="standardpanel container_conteggi" style="padding: 1px; margin-top: 5px;">
        <h5>Parametri opzionali</h5>
        <ng-template [ngIf]="paramForm">
          <form [formGroup]="paramForm" class="form-param-opt container-fluid">
  
            <div class="row">
              <div textInput [control]="paramForm.controls['parametro']" class="col-sm-3"
                (onModelChange)="validationParam($event)" [labelInput]="'Parametro'" formControlName="parametro"
                [maxLength]="25"></div>
  
              <div textInput [control]="paramForm.controls['valore']" class="col-sm-3"
                (onModelChange)="validationParam($event)" [labelInput]="'Valore'" formControlName="valore"
                [maxLength]="25"></div>
  
              <div class="col-sm-3" style="padding-top: 25px;">
                <p>
                  <button (click)="addParam();" type="button" [disabled]="flagParametri"
                    class="btn btn-primary btn-block">Aggiungi</button>
                </p>
              </div>
            </div>
          </form>
        </ng-template>
  
        <ng-template [ngIf]="parametri.length > 0">
          <div class="table-param">
            <table class="table-striped table aggiunta_classificazione">
              <caption class="sr-only">Tabella parametri template</caption>
              <tbody>
                <tr>
                  <th>Parametro</th>
                  <th>Valore</th>
                  <th>Opzioni</th>
                </tr>
                <!-- <ng-template *ngFor="let param of parametri" let-iClass=index> -->
                <tr *ngFor="let param of parametri">
                  <td>{{param.parametro}}</td>
                  <td>{{param.valore}}</td>
                  <td style="display: flex; justify-content: center;"><a href="javascript:void(0);"
                      (click)="removeParam(param);"><span class="glyphicon glyphicon-trash"></span></a></td>
                </tr>
                <!-- </ng-template> -->
              </tbody>
            </table>
          </div>
        </ng-template>
  
      </div>
  
  
  
      <div class="row">
        <div class="col-md-3">
          <button (click)="goBack()" class="btn btn-outline-secondary btn-block ng-star-inserted">Indietro</button>
        </div>
  
        <div class="col-md-6"></div>
  
        <div class="col-md-3">
          <button (click)="generaTemplate(template)" [disabled]="!template || template == ''"
            class="btn btn-primary btn-block">Genera Documento</button>
        </div>
      </div>
    </form>
  </div>
</div>
